export const mutations = {
    setAtividadeCrmProposta(state, payload) {
        state.atividadeCrmProposta = payload
    },
    setAtividadesCrmProposta(state, payload) {
        state.atividadesCrmProposta = payload
    },
    addAtividadeCrmProposta(state, data){
        state.atividadeCrmPropostas.push(data)
    },
    removeAtividadeCrmProposta(state, data){
        let index = state.atividadesCrmProposta.map(x => x.id).indexOf(data.id);
        state.atividadesCrmProposta.splice(index, 1)
    },
    setModalCadastroAtividadeCrmProposta(state, status) {
        state.modalCadastroAtividadeCrmProposta = status
    },
   
    setModalExcluirAtividadeCrmProposta(state, status) {
        state.modalExcluirAtividadeCrmProposta = status
    },
}

export default {}